<script setup lang="ts">
import { computed } from 'vue';

import QuantityStepper from '@/components/base/form/QuantityStepper.vue';

const props = defineProps<{ modelValue: number; productKey: string }>();

const emit = defineEmits<{ 'add-ingredient': [string]; 'remove-ingredient': [string] }>();

const quantity = computed({
  get: () => props.modelValue,
  set: (val) => {
    if (val > props.modelValue) {
      emit('add-ingredient', props.productKey);
    } else if (val < props.modelValue) {
      emit('remove-ingredient', props.productKey);
    }
  },
});
</script>

<template>
  <QuantityStepper v-model="quantity" :min="0" size="small" ariaLabel="ingredient quantity">
    {{ `${quantity} Part${modelValue > 1 ? 's' : ''}` }}
  </QuantityStepper>
</template>
